/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val, i = Math.floor(Math.abs(val));

if (i === 0 || n === 1)
    return 1;
return 5;
}

export default ["doi",[["सवेर","स’ञ"],u,["सवेर","दपैहर बाद"]],[["सवेर","स’ञ"]],[["ऐ.","सो.","म.","बु.","बी.","शु.","श."],["ऐत","सोम","मंगल","बुध","बीर","शुक्र","शनि"],["ऐतबार","सोमबार","मंगलबार","बुधबार","बीरबार","शुक्रबार","शनिबार"],["ऐत","सोम","मंगल","बुध","बीर","शुक्र","शनि"]],[["ऐ","सो","म.","बु.","बी.","शु.","श."],["ऐत","सोम","मंगल","बुध","बीर","शुक्र","शनि"],["ऐतबार","सोमबार","मंगलबार","बुधबार","बीरबार","शुक्रबार","शनिबार"],["ऐत","सोम","मंगल","बुध","बीर","शुक्र","शनि"]],[["ज","फ","मा","अ","मे","जू","जु","अ","सि","अ","न","दि"],["जन.","फर.","मार्च","अप्रैल","मेई","जून","जुलाई","अग.","सित.","अक्तू.","नव.","दिस."],["जनवरी","फरवरी","मार्च","अप्रैल","मेई","जून","जुलाई","अगस्त","सितंबर","अक्तूबर","नवंबर","दिसंबर"]],u,[["ई.पू.","ईसवी"],u,["ई.पू.","ई. सन्"]],0,[0,0],["d/M/yy","d, MMM y","d, MMMM y","EEEE, d, MMMM y"],["h:mm a","h:mm:ss a","h:mm:ss a z","h:mm:ss a zzzz"],["{1}, {0}",u,u,u],[".",",",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##0.###","#,##0%","¤#,##0.00","#E0"],"INR","₹","भारती रपेऽ",{},"ltr", plural];
